export const filtersMixins = {
  filters: {
    formatPrice(price) {
      if (!price) return '--'
      const [a, b] = `${price}`.split('.')
      const fb = b === undefined ? `${a}.00` : `${a}.${b[0]}${b[1] || '0'}`
      return fb.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
